import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import config from '../../configs/config';
import { openDialog } from '../../store/actionCreators/dialogManager';
import { useGlobalContext } from "../../contexts/GlobalContext";
import { classNames } from "../../helpers/pureFunctions";
import './CurrencyChangeWidget.scss';

const CurrencyChangeWidget = ({ fromHeader }) => {
    const dispatch = useDispatch();
    const { publicPath } = useGlobalContext();
    const { t } = useTranslation();

    const openCurrencyExchangeDialog = () => {
        dispatch(openDialog({ dialogType: 'currencyExchange' }));
    };

    return (
        <div className={classNames({'header__currency_exchange' : fromHeader , 'user-settings-dialog__currency-wrapper' : !fromHeader}  )}>
            {!fromHeader ? (
                <>
                  <i className="user-settings-dialog__history-icon icon-changes" />
                  <span className="user-settings-dialog__history-text">{t('currencyExchange')}</span>
                  <span onClick={openCurrencyExchangeDialog} className="user-settings-dialog__terms-and-conditions-link">
                     {t('currency')}
                  </span>
                </>
            ) : (
                <div onClick={openCurrencyExchangeDialog}>
                    <img src={`${publicPath}images/tournamentsHistory/currency-exchange.svg`} alt="currency-exchange"  width={35}/>
                </div>
            )}
        </div>
    );
};

export default CurrencyChangeWidget;
